/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_DescriptionInputs */



/**
* | output |
* | --- |
* | "Import plain text and configure import settings" |
*
* @param {Plain_Text_Import_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_description = /** @type {((inputs?: Plain_Text_Import_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer du texte brut et configurer les parametres d'importation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Klartext importieren und Importeinstellungen konfigurieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa testo normale e configura le impostazioni di importazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импортируйте текстовый файл и настройте параметры импорта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar texto sin formato y configurar los ajustes de importación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入纯文本并配置导入设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレーンテキストをインポートし、インポート設定を構成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("साधारण टेक्स्ट आयात करें और आयात सेटिंग्स कॉन्फ़िगर करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importe texto simples e configure as opções de importação.")
	return /** @type {LocalizedString} */ ("Import plain text and configure import settings")
});